import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=64cf4d83&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=64cf4d83&prod&scoped=true&lang=css&"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=64cf4d83&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf4d83",
  null
  
)

export default component.exports